import { render } from "./ListPagination.vue?vue&type=template&id=d8be6212&scoped=true"
import script from "./ListPagination.vue?vue&type=script&lang=js"
export * from "./ListPagination.vue?vue&type=script&lang=js"

import "./ListPagination.vue?vue&type=style&index=0&id=d8be6212&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8be6212"]])

export default __exports__